module.exports = __webpack_public_path__ + "static/media/icon_less_than_or_equal_to.e094768b.svg";